/**
 * Created by H
 * User: huangcan
 * Date: 2019/6/6
 * Time: 1:37 PM
 * tips:
 */

import draggable from 'vuedraggable'

export default {
  components: {
    draggable
  },
  data() {
    this.timeStamp = -1
    this.index = 0
    this.dragOptions = {
      animation: 300,
      disabled: false
    }
    this.editorComponentIndex = []
    return {
      activeName: '',
      componentShow: [],
      marks: {
        0: '0s',
        60: '60s'
      }
    }
  },
  computed: {
    drag1() {
      return Object.assign({}, this.dragOptions, {
        animation: 0,
        group: { name: 'app', pull: 'clone', put: false },
        disabled: false
      })
    },
    drag2() {
      return Object.assign({}, this.dragOptions, {
        group: 'app',
        disabled: false
      })
    }
  },
  watch: {
    home: {
      handler(v) {
        this._viewArea()
      },
      deep: true
    }
  },
  methods: {
    /**
     * 双击移除模块,单击编辑模块
     * @param obj (dom对象)
     */
    chooseItem(obj) {
      if (this.timeStamp === -1) {
        this.timeStamp = obj.timeStamp
      }
      if (
        obj.timeStamp - this.timeStamp > 300 ||
        obj.timeStamp - this.timeStamp === 0
      ) {
        // 此时是单击
        this.timeStamp = obj.timeStamp
        // 弹出旁边模块编辑列表
        this.activeName = obj.item.dataset.index
      }
      if (
        obj.timeStamp - this.timeStamp <= 300 &&
        obj.timeStamp - this.timeStamp > 0
      ) {
        // 2次点击时间差值小于300ms，判断此刻用户是双击
        this.componentShow.splice(obj.oldIndex, 1)
        // 重新初始化
        this.timeStamp = -1
      }
    },
    /**
     * 添加图片数
     * @param item
     * @param file
     * @private
     */
    _handleAddItemData(item, file) {
      item.img.push(file)
      item.imgUrl = file.url
    },
    /**
     * 图片移除
     * @param item
     * @private
     */
    _handleRemove(item) {
      item.img = []
      item.imgUrl = ''
    },
    /**
     * 模块添加项
     * @param data （模块数据）
     * @param moduleName (模块名字)
     * @param limit （最大限制数）
     * @returns {string}
     */
    moduleAddItem(data, moduleName, limit) {
      if (data.length >= limit) {
        this.$notify({
          message: '已添加到最大项了哟~！',
          type: 'warning'
        })
        return
      }
      const custome = {
        img: [],
        imgUrl: '',
        link: ''
      }
      switch (moduleName) {
        case 'banner':
          data.push(custome)
          break
        case 'newProduct':
          data.push(custome)
          break
        case 'brandCode':
          data.push({
            brandCode: '',
            link: ''
          })
          break
        case 'nav':
          data.push({
            ...custome,
            name: ''
          })
          break
        case 'group':
          data.push({
            title: '',
            ad: '',
            list: [
              {
                img: [],
                imgUrl: '',
                link: ''
              },
              {
                img: [],
                imgUrl: '',
                link: ''
              },
              {
                img: [],
                imgUrl: '',
                link: ''
              }
            ]
          })
          break
        case 'group2':
          data.push({
            title: '',
            ...custome
          })
          break
        case 'producing':
          data.push({
            subBanner: {
              img: [],
              imgUrl: ''
            },
            category: [
              {
                input: '',
                list: [
                  {
                    img: [],
                    imgUrl: '',
                    link: ''
                  },
                  {
                    img: [],
                    imgUrl: '',
                    link: ''
                  },
                  {
                    img: [],
                    imgUrl: '',
                    link: ''
                  },
                  {
                    img: [],
                    imgUrl: '',
                    link: ''
                  }
                ]
              },
              {
                input: '',
                list: [
                  {
                    img: [],
                    imgUrl: '',
                    link: ''
                  },
                  {
                    img: [],
                    imgUrl: '',
                    link: ''
                  },
                  {
                    img: [],
                    imgUrl: '',
                    link: ''
                  },
                  {
                    img: [],
                    imgUrl: '',
                    link: ''
                  }
                ]
              },
              {
                input: '',
                list: [
                  {
                    img: [],
                    imgUrl: '',
                    link: ''
                  },
                  {
                    img: [],
                    imgUrl: '',
                    link: ''
                  },
                  {
                    img: [],
                    imgUrl: '',
                    link: ''
                  },
                  {
                    img: [],
                    imgUrl: '',
                    link: ''
                  }
                ]
              }
            ]
          })
          break
        case 'wineryRec':
          data.push({
            ...custome,
            name: '',
            discount: ''
          })
          break
        case 'support':
          data.push({
            ...custome,
            name: '',
            intro: ''
          })
          break
        case 'notesPenfriend':
          data.push({
            avatar: '',
            name: '',
            id: '',
            level: ''
          })
          break
        case 'notes':
          const { field, active } = this.home.fileListNotes
          if (!field[active]) {
            this.$set(field, active, [])
          }
          field[active].push({
            avatar: '',
            img: [],
            imgUrl: '',
            name: '',
            id: '',
            level: '',
            pel_level: 2,
            noteId: '',
            content: ''
          })
          break
      }
    },
    /**
     * 设置索引
     * @param el (dom元素)
     */
    setItemIndex(el) {
      this.index = el.oldIndex
    },
    /**
     * 删除项目 (至少保留1项数据)
     * @param list
     * @param type
     * @param index
     */
    delItem(list, type, index) {
      if (type === 'group') {
        const groupItem = list[index]
        groupItem.list.splice(this.index, 1)
        if (groupItem.list.length === 0) list.splice(index, 1)
        return
      }
      if (type === 'producing') {
        list.splice(index, 1)
        return
      }
      list.splice(this.index, 1)
    },
    /**
     *  上传
     * @param field
     * @private
     */
    _handleUpload(field) {
      this.formData = new FormData()
      if (this.$refs[field])
        this.$refs[field].forEach(v => {
          v.submit()
        })
    },
    /**
     * 模块数据保存
     * @param data
     * @param field
     */
    moduleSaveData(data, field) {
      const renovationId = this.$route.query.id || this.renovationId
      this._handleUpload(field)
      const appendData = (field, data) => this.formData.append(field, data)
      appendData(field, JSON.stringify(data))
      if (renovationId) {
        appendData('renovation_id', renovationId)
      }
      if (this.appletsId) {
        appendData('applet_id', this.appletsId)
      }
      if (this.decorationMethod) {
        appendData('decoration_method', this.decorationMethod)
      }
      if (this.screenId) {
        appendData('led_id', this.screenId)
        appendData('page_name', this.pageName)
      }
      if (this.renovationName) {
        appendData('renovation_name', this.renovationName)
      }
      appendData('renovation_type', this.renovationType)
      this.api.saveDecorationFormData(this.formData).then(res => {
        this.renovationId = res.renovation_id
        this.$notify({
          type: 'success',
          message: '保存成功~！😝'
        })
      })
    },
    /**
     * 检测浏览区域是否有对应模块
     * @param activeName
     */
    handleCheck(activeName) {
      const index = this.componentShow.findIndex(v => {
        return v.index === activeName
      })
      if (index === -1 && activeName !== '') {
        this.$notify({
          type: 'warning',
          message: '请先添加对应模块到浏览区域~！🤔'
        })
      }
    },
    /**
     * 图片信息追加到formData
     * @param imgData
     * @private
     */
    _appendFormDataInfo(imgData) {
      const { raw, uid } = imgData.img[0]
      this.formData.append(`image_file_${uid}`, raw)
    },
    /**
     * 编辑的时候添加模块到浏览区域
     * @param obj
     * @private
     */
    _addModules(obj) {
      const component = (this.decorationMethod == '1') ? this.utils._cloneDeep(this.componentSelect) : this.utils._cloneDeep(this.componentSelect1)
      this.componentShow = component.filter(v => {
        return obj.hasOwnProperty(v.props)
      })
      this.componentShow.forEach(v => {
        this.editorComponentIndex.push(v.index)
      })
    },
    /**
     * 浏览区域组件在有数据的时候更新上去
     * @private
     */
    _viewArea() {
      const handlerUpdate = index => {
        const obj = this.componentShow.find(item => {
          return item.index === index
        })
        this.$nextTick(() => {
          const child = this.$refs[`view${index}`]
          if (child)
            child[0]._updateData(this.home[obj.props], this.activeIndex || 0)
        })
      }
      const comp = this.editorComponentIndex
      if (comp.length > 0) {
        comp.forEach(val => {
          handlerUpdate(val)
        })
        this.editorComponentIndex = []
      } else {
        handlerUpdate(this.activeName)
      }
    }
  }
}
